import {observer} from "mobx-react";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {
    Container, ContainerDescription, ContainerEditDescription,
    Content,
    ContentDataInternalChat, ContentLineClamp, IconEdit, TextDescriptionProblem, TextOpenedByUser
} from "@dropDesk/presentation/components/internal_chat_view/header_view_information/styled";
import AvatarImage from "@dropDesk/presentation/components/avatar";
import React, {useContext} from "react";
import {BadgeOriginEnum} from "@dropDesk/domain/entities/ticket/ticket_maps";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {MenuCollapsedContext} from "@dropDesk/presentation/routes/private_route";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const HeaderViewInformation = observer(
    ({
         internalChat,
         canChangeDescription,
         widthContainerListChats,
         onClickEditDescription
     }: {
        internalChat: InternalChatEntity
        canChangeDescription: boolean
        widthContainerListChats?: number
        onClickEditDescription: () => void
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const collapsed = useContext(MenuCollapsedContext);
        const widthContainerProfile = 61;
        const widthHeader = ((widthContainerListChats ?? 0) + (collapsed ? 80 : 250) + widthContainerProfile + 100);

        return (
            <Container>
                <Content>
                    <ContentDataInternalChat>
                        <AvatarImage
                            useCursorPointer={false}
                            title={internalChat.description}
                            size={45}
                            round={true}
                            hasPreviewImage={false}
                            letterSize={20}
                            isBackgroundChat={true}
                            badgeOrigin={BadgeOriginEnum.internalChat}
                        />
                        <ContainerDescription>
                            <ContainerEditDescription
                                color={colors.text} canChange={canChangeDescription} onClick={onClickEditDescription}
                            >
                                <ContentLineClamp width={widthHeader}>
                                    <Tooltip title={"Título do chat interno"}>
                                        <TextDescriptionProblem color={colors.text}>
                                            {internalChat.description}
                                        </TextDescriptionProblem>
                                    </Tooltip>
                                </ContentLineClamp>
                                <IconEdit
                                    size={13}
                                    className={`icon-${ICONS_DROPDESK.edit}`}
                                    color={colors.text}
                                />
                            </ContainerEditDescription>
                            <ContentLineClamp width={widthHeader}>
                                <TextOpenedByUser color={colors.text}>
                                    Criado por {internalChat.openedByUser?.name}
                                </TextOpenedByUser>
                            </ContentLineClamp>

                        </ContainerDescription>
                    </ContentDataInternalChat>
                </Content>
            </Container>
        );
    });
export default HeaderViewInformation;